import { Form } from '@tribeplatform/react-components/Form'
import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { useAuthToken, useUpdateMember } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

import { CountryLanguage } from './CountryLanguage.js'

export const LanguageSettings = () => {
  const { $t } = useI18n()
  const {
    data: { member, network },
  } = useAuthToken()
  const { mutateAsync: updateMember, isLoading } = useUpdateMember()

  const availableLocales = (network?.availableLocales || ['en-US']).map(
    locale => {
      return {
        value: locale,
        text: <CountryLanguage locale={locale} />,
      }
    },
  )

  if (availableLocales?.length <= 1) {
    return null
  }

  return (
    <Card>
      <Card.Header
        title={<T defaultMessage="Language" id="Generics.Language" />}
      />
      <Card.Content>
        <Form
          defaultValues={{
            locale: member?.locale,
          }}
          onSubmit={async data => {
            const { locale } = data
            await updateMember({
              id: member?.id,
              input: {
                locale,
              },
            })
            toast({
              title: $t({
                defaultMessage: 'Preferred language updated.',
                id: 'Settings.Language.PreferenceUpdated',
              }),
              status: 'success',
            })
            window.location.reload()
          }}
        >
          {({ formState: { isDirty } }) => (
            <div className="web:col-span-12 web:md:col-span-8 flex flex-col space-y-5">
              <Form.Select
                name="locale"
                label={
                  <T
                    defaultMessage="Preferred language"
                    id="Settings.Language.Preference"
                  />
                }
                helperText={
                  <T
                    defaultMessage="Translate the {COMMUNITY} interface and posts to your preferred language."
                    id="Settings.Language.Preference.Helper"
                  />
                }
                items={availableLocales}
              />
              <Form.Actions>
                <Button
                  type="submit"
                  loading={isLoading}
                  disabled={!isDirty}
                  size="lg"
                >
                  <T defaultMessage="Update" id="Generics.Update" />
                </Button>
              </Form.Actions>
            </div>
          )}
        </Form>
      </Card.Content>
    </Card>
  )
}
